var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 799.9943848 1000",
    style: {
      enableBackground: "new 0 0 799.9943848 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FF4433;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.9971924,
    y1: 1001.164856,
    x2: 399.9971924,
    y2: 1.1648352,
    gradientTransform: "matrix(1 0 0 -1 0 1001.164856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F22411"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.0003631,399.9822083C0.0003631,179.087204,179.0875397,0,400.0122375,0 c220.894989,0,399.9821472,179.087204,399.9821472,399.9822083c0,110.4474792-44.7495117,210.4059143-117.0736694,282.7895813 c-18.8982544,18.8981934-44.4821777,39.9952393-72.1460571,62.845459 c-78.3264771,64.6282349-173.382019,143.0736084-180.7808533,224.371521C428.5081177,986.4801025,416.5630188,1000,399.9824829,1000 c-16.5507507,0-28.4958496-13.5200195-29.9815979-30.0112305c-7.3988342-81.2979126-102.4543762-159.7432861-180.7808838-224.371521 c-27.6341705-22.8502197-53.2180634-43.9472656-72.1162491-62.845459 C42.0009155,607.8423462-0.1427135,506.0710144,0.0003631,399.9822083z M540.0253906,400.0119019 c1.1262207,77.3188782-60.6400757,140.9112549-137.9590149,142.0374756 c-77.3188477,1.1262207-140.9111938-60.6400757-142.0374451-137.9589539c-0.0197754-1.3594055-0.0197754-2.7190857,0-4.0785217 c1.1262512-77.3188477,64.7185974-139.0851746,142.0374451-137.9589233 C477.7974243,263.1560364,538.9222412,324.2809143,540.0253906,400.0119019z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.0003631,399.9822083C0.0003631,179.087204,179.0875397,0,400.0122375,0 c220.894989,0,399.9821472,179.087204,399.9821472,399.9822083c0,110.4474792-44.7495117,210.4059143-117.0736694,282.7895813 c-18.8982544,18.8981934-44.4821777,39.9952393-72.1460571,62.845459 c-78.3264771,64.6282349-173.382019,143.0736084-180.7808533,224.371521C428.5081177,986.4801025,416.5630188,1000,399.9824829,1000 c-16.5507507,0-28.4958496-13.5200195-29.9815979-30.0112305c-7.3988342-81.2979126-102.4543762-159.7432861-180.7808838-224.371521 c-27.6341705-22.8502197-53.2180634-43.9472656-72.1162491-62.845459 C42.0009155,607.8423462-0.1427135,506.0710144,0.0003631,399.9822083z M540.0253906,400.0119019 c1.1262207,77.3188782-60.6400757,140.9112549-137.9590149,142.0374756 c-77.3188477,1.1262207-140.9111938-60.6400757-142.0374451-137.9589539c-0.0197754-1.3594055-0.0197754-2.7190857,0-4.0785217 c1.1262512-77.3188477,64.7185974-139.0851746,142.0374451-137.9589233 C477.7974243,263.1560364,538.9222412,324.2809143,540.0253906,400.0119019z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYa);
export default __webpack_public_path__ + "static/media/ya.1940dc10abe53dffc023e3928a4a0128.svg";
export { ForwardRef as ReactComponent };